<template>
    <!-- <div v-if="isVisible" >
        <button class="btn bo-dropdown-toggle" type="button" data-toggle="dropdown" :disabled="!editable">
            <slot v-if="selected" name="selected-item" :item="selected">
                {{ selected.label }}
            </slot>
        </button>

        <div class="dropdown-menu">
            <div
                @click="select(item)"
                v-for="(item, index) in value"
                :class="['dropdown-item', { active: selected && selected.id == item.id }]"
                :key="index"
            >
                <slot name="item" :item="item">
                    {{ item.label }}
                </slot>
            </div>
        </div>
    </div> -->
    <select
        :class="['bo-dropdown-menu', dropdownStyle]"
        :disabled="disabled"
        :value="valueId"
        @input="onInput"
    >
        <option v-for="option in options" :value="option.id" :key="option.id">{{ option.label }}</option>
    </select>
</template>

<script>
export default {
    props: {
        options: {
            type: [Array, Object],
            default: [],
        },
        value: {
            type: [Array, Object],
            default: [],
        },
        dropdownStyle: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        // always show the bound value, even when the parent rejects a selection
        controlled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        valueId: {
            get() {
                return this.value.id;
            },
        },
    },

    methods: {
        onInput(event) {
            this.$emit("input", this.options[event.target.value]);
            if (!this.controlled) {
                return;
            }
            this.$nextTick(() => {
                if (this.$el.value != this.valueId) {
                    this.$el.value = this.valueId;
                }
            });
        },
    },
};
</script>
